import Vue from 'vue'
import Vuex from 'vuex'
import sincronizador from '../components/Sincronizador/state'
import marcacao from '../components/Marcacao/state'
import VuexPersistence from 'vuex-persist'
import register from '../components/Register/state'
import Cookies from 'js-cookie'
import createPersistedState from 'vuex-persistedstate'
import coletor from '../components/Coletor/state'
import solicitacao from '../components/Solicitacoes/state'
import * as Sentry from '@sentry/vue'
import { Http } from 'vue-resource'
import { gerarUrlLogout, gerarUrlRedirectSSORoute, gerarUrlWebVisual, gerarUrlSalvarTokenFirebase } from '../api'
import { formatarObjetoWebParaSentry } from '../sentry.ts'

Vue.use(Vuex)

export const persistentKey = 'vuex-persistent'

export const persistor = new VuexPersistence({
  key: 'web',
  modules: ['accessData', 'visualConfigs', 'buscouVisualsColetor', 'coletor', 'modalRecaptcha']
})

function defaultState () {
  return {
    executingSAMLLogin: false,
    accessData: {
      compMan: null,
      browserRecord: null,
      cognitoInfo: null,
      solarInfo: null,
      timezoneUltimoPonto: null,
      localDeTrabalhoUltimoPonto: null,
      timeZoneLocalDeTrabalho: null,
      coletor: {
        coletorId: null,
        chaveDispositivo: null,
        clientId: null,
        tokenColetor: null,
        coletorPendente: null,
        tipoColetor: null,
        localPadraoEmpregadoSincronizado: null
      },
      regularToken: null
    },
    visualConfigs: null,
    buscouVisualsColetor: null,
    rotaAnterior: null,
    modalRecaptcha: null,
    workerSSOAtivo: null
  }
}

/**
 * @type {VuexPersistence}
 * @description Persistência de dados do Vuex no LocalStorage
 * para manter dados importantes como tokenColetor e outros
 * e evitar que o usuário tenha que logar novamente
 * As stores persistidas são as atribuidas no reducer
 */
const persistenciaLocalStorage = new VuexPersistence({
  storage: window.localStorage,
  key: 'web',
  reducer: (state) => ({
    accessData: state.accessData,
    visualConfigs: state.visualConfigs,
    buscouVisualsColetor: state.buscouVisualsColetor,
    coletor: state.coletor,
    modalRecaptcha: state.modalRecaptcha
  })
})

const pluginsEmpresasDescadastrando = [persistenciaLocalStorage.plugin]
const plugionsDemaisEmpresas = [
  createPersistedState({
    'key': 'web',
    'paths': ['accessData', 'visualConfigs', 'buscouVisualsColetor', 'coletor']
  }), persistor.plugin]

const dicionarioEmailsEmpresasDescadastrando = {
  '61fd1484726c4dacae2ed299': 'lar21@bancodaycovalsa.com.br',
  '5f7f5d8db46fc1793e8d042d': 'lar21@sociedade-brasileira-de-patologia-clinicamedicina-laboratorial.com.br',
  '63568fce9b679d810190386a': 'lar21@vibraenergiasa.com.br',
  '64ad732d590bae0ee0b6adde': 'lar21@palatini.com.br'
}

function verificaIdNoDicionario (id) {
  return dicionarioEmailsEmpresasDescadastrando.hasOwnProperty(id)
}

function buscaClientIdNoLocalStorage () {
  const dadosWeb = localStorage.getItem('web')

  if (dadosWeb) {
    const dados = JSON.parse(dadosWeb)

    if (dados && dados.accessData && dados.accessData.coletor && dados.accessData.coletor.clientId) {
      return dados.accessData.coletor.clientId
    }
  }

  return null
}

const escolherPluginsPorEmpresaLogada = () => {
  const clienteIdPrevio = buscaClientIdNoLocalStorage()

  if (verificaIdNoDicionario(clienteIdPrevio)) {
    console.log(`O ID=${clienteIdPrevio} está no dicionário.`)
    return pluginsEmpresasDescadastrando
  } else {
    console.log(`O ID=${clienteIdPrevio} não está no dicionário.`)
    return plugionsDemaisEmpresas
  }
}

const store = new Vuex.Store({
  plugins: [...escolherPluginsPorEmpresaLogada()],
  state: defaultState(),
  getters: {
    visual: function (state) {
      return state.visualConfigs ? state.visualConfigs.visual : {}
    },
    ehColetorSSO (state) {
      const ehSSOSAML = state.accessData.cognitoInfo?.isSamlLogin
      const ehSSOSolar = state.accessData.solarInfo

      return Boolean(ehSSOSAML || ehSSOSolar)
    }
  },
  mutations: {
    resetData (state) {
      Object.assign(state, defaultState())
    },
    setCompMan (state, { id, name, displayedName, logo }) {
      state.accessData.compMan = {
        id, name, displayedName, logo
      }
    },
    // eslint-disable-next-line camelcase
    setBrowserRecord (state, { id, personal, employee, companies, recaptcha, style, active, comp_man, fallback }) {
      state.accessData.browserRecord = {
        id, personal, employee, companies, recaptcha, style, active, fallback
      }
      // eslint-disable-next-line camelcase
      state.accessData.compMan = comp_man
    },
    _visualConfigs (state, { isDefault, visual, fileWeb }) {
      state.visualConfigs = { isDefault, visual, fileWeb }
    },
    cognitoInfo (state, payload) {
      state.accessData.cognitoInfo = { ...(state.accessData.cognitoInfo || {}), ...payload }
    },
    solarInfo (state, payload) {
      state.accessData.solarInfo = { ...(state.accessData.solarInfo || {}), ...payload }
      Cookies.set('Authorization', state.accessData.solarInfo.authorization)
    },
    executingSAMLLogin (state, payload) {
      state.executingSAMLLogin = Boolean(payload)
    },
    atribuiRotaAnterior (state, rotaAnterior) {
      state.rotaAnterior = rotaAnterior
    },
    regularToken (state, token) {
      state.accessData.regularToken = token
    },
    coletorId (state, id) {
      state.accessData.coletor.coletorId = id
    },
    chaveDispositivo (state, chaveDispositivo) {
      state.accessData.coletor.chaveDispositivo = chaveDispositivo
    },
    clientId (state, id) {
      state.accessData.coletor.clientId = id
    },
    tokenColetor (state, token) {
      state.accessData.coletor.tokenColetor = token
    },
    coletorPendente (state, status) {
      state.accessData.coletor.coletorPendente = status
    },
    tipoColetor (state, tipo) {
      state.accessData.coletor.tipoColetor = tipo
    },
    localPadraoEmpregadoSincronizado (state, localPadrao) {
      state.accessData.coletor.localPadraoEmpregadoSincronizado = localPadrao
    },
    timezoneUltimoPonto (state, timezone) {
      state.accessData.timezoneUltimoPonto = timezone
    },
    localDeTrabalhoUltimoPonto (state, localDeTrabalho) {
      state.accessData.localDeTrabalhoUltimoPonto = localDeTrabalho
    },
    timeZoneLocalDeTrabalho (state, timezone) {
      state.accessData.timeZoneLocalDeTrabalho = timezone
    },
    buscouVisualsColetor (state, status) {
      state.buscouVisualsColetor = status
    },
    modalRecaptcha (state, status) {
      state.modalRecaptcha = status
    },
    workerSSOAtivo (state, statuts) {
      state.workerSSOAtivo = statuts
    }
  },
  actions: {
    async getVisual ({ state, commit, dispatch }) {
      const { coletor: { clientId, coletorId } } = state.accessData

      if (!state.visualConfigs || !state.buscouVisualsColetor) {
        try {
          if (clientId && coletorId) {
            const result = await Http.get(gerarUrlWebVisual(clientId, coletorId))
            commit('buscouVisualsColetor', true)
            commit('_visualConfigs', result.body.success)
          } else {
            const result = await Http.get(gerarUrlWebVisual())
            commit('_visualConfigs', result.body.success)
          }
        } catch (e) {
          if (state && state.visualConfigs && state.visualConfigs.visual !== '') {
          } else {
            const defaultJson = {
              fileWeb: 'https://s3.amazonaws.com/pontotel-styles-local/web/default.css',
              isDefault: true,
              visual: ''
            }
            commit('_visualConfigs', defaultJson)
          }
        }

        // 2º Load the css file
        dispatch('_getFileVisual',
          { fileUrl: state.visualConfigs.fileWeb, faviconUrl: state.visualConfigs.visual.favicon }
        )
      }
    },
    // eslint-disable-next-line no-empty-pattern
    _getFileVisual ({ state }, { fileUrl, faviconUrl }) {
      // Load the custom style of comp_man/employer or the default one
      const customStyleContainerId = 'customStyleContainer'

      let container = document.getElementById(customStyleContainerId)
      let favicon = document.getElementById('favicon')
      const BancoVotorantim = '5cd49411d28021000c09e013'

      if (container) {
        container.href = fileUrl
        favicon.href = faviconUrl
      } else if (!container) {
        container = document.createElement('link')
        container.href = fileUrl
        container.id = customStyleContainerId
        container.type = 'text/css'
        container.rel = 'stylesheet'
        document.getElementsByTagName('head')[0].append(container)
        favicon.href = faviconUrl
      }
      if (state.accessData.coletor.clientId === BancoVotorantim) {
        document.documentElement.style.setProperty('--font-family', 'FrutigerLTStd-Cn')
      }
    },
    async logout ({ state }) {
      if (!state.accessData.compMan) {
        Sentry.captureEvent({
          message: 'Coletor deslogado, não há compMan (clear)',
          contexts: {
            localStorage: {
              web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
            }
          }
        })
        localStorage.clear()
        window.location.href = window.location.origin
      }

      const compManId = state.accessData.compMan.id

      try {
        await Http.get(gerarUrlLogout())
      } catch (erro) {
        Sentry.captureException(erro)
      }

      const result = await Http.get(gerarUrlRedirectSSORoute(compManId))

      function unicodeUnEscape (string) {
        return string.replace(/%u([\dA-Z]{4})|%([\dA-Z]{2})/g, function (_, m1, m2) {
          return String.fromCharCode(parseInt('0x' + (m1 || m2)))
        })
      }

      Sentry.captureEvent({
        message: 'Coletor deslogado (logout)',
        contexts: {
          localStorage: {
            web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
          }
        }
      })
      localStorage.clear()
      if (result.body && result.body.success && result.body.success.redirectWeb) {
        window.location.href = unicodeUnEscape(result.body.success.redirectWeb)
      } else {
        window.location.href = window.location.origin
      }
    },
    async clear () {
      Sentry.captureEvent({
        message: 'Coletor Deslogado',
        contexts: {
          localStorage: {
            web: formatarObjetoWebParaSentry(window.localStorage.getItem('web'))
          }
        }
      })
      setTimeout(() => {
        window.localStorage.clear()
        window.location.href = window.location.origin + window.location.pathname
      }, 500)
    },
    async salvarTokenFirebase (_, idEmpregado) {
      try {
        const permisaoNotificacao = await Notification.requestPermission()

        if (permisaoNotificacao !== 'granted') {
          console.warn('Permissão de Notificações recusada pelo usuário')
          return
        }

        const firebaseToken = await window.firebaseMessaging.getToken()
        if (firebaseToken) {
          await Http.post(gerarUrlSalvarTokenFirebase(idEmpregado), { firebaseToken })
        }
      } catch (erro) {
        Sentry.captureException(erro)
      }
    }
  },
  modules: {
    sincronizador,
    marcacao,
    register,
    coletor,
    solicitacao
  }
})

window.vuex = store

export default store
